"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var API_1 = require("../API");
var Severity;
(function (Severity) {
    Severity["Warning"] = "Warning";
    Severity["Info"] = "Info";
})(Severity = exports.Severity || (exports.Severity = {}));
var Language;
(function (Language) {
    Language["EN_GB"] = "en-GB";
    Language["FR_BE"] = "fr-BE";
    Language["FR_FR"] = "fr-FR";
    Language["DE_BE"] = "de-BE";
    Language["DE_DE"] = "de-DE";
    Language["NL_BE"] = "nl-BE";
    Language["NL_NL"] = "nl-NL";
})(Language = exports.Language || (exports.Language = {}));
var DoorPreference;
(function (DoorPreference) {
    DoorPreference["RING_DOORBELL"] = "RING_DOORBELL";
    DoorPreference["KNOCK_ON_DOOR"] = "KNOCK_ON_DOOR";
    DoorPreference["KNOCK_ON_WINDOW"] = "KNOCK_ON_WINDOW";
})(DoorPreference = exports.DoorPreference || (exports.DoorPreference = {}));
var BuildingType;
(function (BuildingType) {
    BuildingType["HOUSE"] = "HOUSE";
    BuildingType["OFFICE"] = "OFFICE";
    BuildingType["HIGH_RISE"] = "HIGH_RISE";
})(BuildingType = exports.BuildingType || (exports.BuildingType = {}));
var TrackTrace = /** @class */ (function (_super) {
    __extends(TrackTrace, _super);
    /**
     * Creates a new instance of the Tracking API.
     * @param {string} shipmentReference The reference of the shipment
     * @param {string} postalCode The postal code of the shipment.
     */
    function TrackTrace(shipmentReference, postalCode) {
        var _this = this;
        var data = shipmentReference + ":" + postalCode;
        var base64Part = typeof btoa === 'function'
            ? btoa(data)
            : new Buffer(data).toString('base64');
        var authorizationHeader = "Basic " + base64Part;
        _this = _super.call(this, 'Authorization', authorizationHeader) || this;
        _this.shipmentReference = shipmentReference;
        _this.postalCode = postalCode;
        return _this;
    }
    /**
     * Fetches a ticket which can be used to establish a websocket connection with.
     * This ticket/websocket will be tied to receiving driver location updates.
     * @returns { string } ticket which can be used for establishing a websocket connection.
     */
    TrackTrace.prototype.getWebsocketTicket = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.post('/tracing/ticket')];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.ticketId];
                }
            });
        });
    };
    /**
     * List today's informational and warning messages.
     */
    TrackTrace.prototype.getTodaysMessages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.get('/tracing/todays-messages')];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * Verifies whether the supplied details are correct.
     * @returns {Promise<boolean>} Reflects whether the details are correct.
     */
    TrackTrace.prototype.verifyShipmentDetails = function () {
        return __awaiter(this, void 0, void 0, function () {
            var axiosError_1, isRefNotFound;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.client.get('/tracing/verify')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        axiosError_1 = _a.sent();
                        isRefNotFound = axiosError_1.response && axiosError_1.response.status === 401;
                        if (!isRefNotFound) {
                            throw axiosError_1;
                        }
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetches track and trace related shipment details
     * @returns { ITracingShipmentDetails } A list of information on a particular shipment.
     */
    TrackTrace.prototype.getShipmentDetails = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.get('/tracing/details')];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * fetches the initial location of the driver if the shipment is allowed to look into it.
     * @returns { IInitialTracing } A list of information on a particular shipment.
     */
    TrackTrace.prototype.getInitialDriverTrace = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.get('/tracing/trace-driver')];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * Fetches whether or not shipping preferences have been set
     * @returns { Promise<IGetSetPreferencesResponse> } A boolean list of set preferences on a particular shipment.
     */
    TrackTrace.prototype.getSetPreferences = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.get('/tracing/shipping-preferences')];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * Set the following shipping preferences: sms subscription, door preference, building type, preferred neighbours
     * Any of the preferences are optional in the input. If the supplied preference does not exist, it will be created.
     * Otherwise, it will be updated. Setting null will clear the preference.
     * @param { ISetPreferencesRequest } request The model representing the set shipping preferences request
     * @returns { Promise<ISetPreferencesResponse> } If successful, returns a list of the upserted preferences
     */
    TrackTrace.prototype.setShippingPreferences = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.post('/tracing/shipping-preferences', request)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * Delete neighbour preferences for the shipment
     */
    TrackTrace.prototype.deleteNeighbourPreferences = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.delete('/tracing/shipping-preferences/neighbour')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Exchange a postalCode and a houseNumber for a valid address
     * Also includes the next possible delivery date if a shipment's address may be changed
     * @param { string } postalCode
     * @param { number } houseNumber
     * @returns { Promise<ICheckAddressResponse> }
     */
    TrackTrace.prototype.checkAddress = function (postalCode, houseNumber) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.get("/tracing/shipment/location?postalCode=" + postalCode + "&houseNumber=" + houseNumber)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * Changes the delivery address via postcode lookup.
     * When the address changes to a different subco region the shipment will also be postponed
     * @param { string } postalCode
     * @param { number } houseNumber
     * @returns { Promise<IChangeAddressResponse> } The delivery date, new location, and new shipment logs
     */
    TrackTrace.prototype.changeAddress = function (postalCode, houseNumber) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.post('/tracing/shipment/location', { postalCode: postalCode, houseNumber: houseNumber })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return TrackTrace;
}(API_1.API));
exports.TrackTrace = TrackTrace;
